import styled from "styled-components";

export const SAddNewItemModalButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
